import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "juou-title" }, "我的底部", -1)

import Advertising from '@/components/Advertising.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Advertising, { position: "mine" })
  ]))
}
}

})